/* eslint-disable @typescript-eslint/no-unused-vars */
/**
 * AUTO-GENERATED REACT QUERY HOOKS - DO NOT EDIT
 * Generated from: MerchantDashboardContract
 */

import { merchantdashboardApi } from '../api/merchantdashboard.api';
import { createQueryHook } from './base.hooks';
import { queryKeys } from './query-keys';
import type { GetDashboardParamsType, GetDashboardResponseType } from '@zlinkx/shared-v2';
import type { HookOptions, MutationHookReturn, QueryHookReturn } from '@/types/hook-generated.types';

export const useGetDashboard = createQueryHook<GetDashboardResponseType['data'], { merchantId: GetDashboardParamsType['merchantId'] }>(
  ({ merchantId }) => merchantdashboardApi.getDashboard(merchantId),
  ({ merchantId }) => queryKeys.merchantdashboard.getDashboard(merchantId)
);